<template>
  <div id="app">

     <router-view/>
     <!-- 全局音乐小卡片：仅超级管理员可见，全站悬浮左下角 -->
     <music-player/>
  </div>
</template>

<script>

import MusicPlayer from './components/MusicPlayer.vue'

export default {
  name: 'App',
  components: {
    MusicPlayer
  }
}
</script>

<style>

#app {
    height: 100%;
}
</style>
